import { useId } from "react";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none">
      <path d="M4 16c4-7 12-9 18-6l6-5-1 9 1 9-6-5c-6 3-14 1-18-6z" fill="#FFB800" />
      <circle cx="11" cy="15" r="1.6" fill="#0B0E14" />
    </svg>
    <span className="font-display text-base sm:text-lg font-black tracking-tight leading-none">
      SWEEPSTAKES<span className="gc-text">GAMES</span>
    </span>
  </div>
);

const FLAT = {
  sc: { label: "SC", from: "#a78bfa", mid: "#7c3aed", to: "#4c1d95", ring: "#ddd6fe", alt: "Sweeps Coin" },
  usdc: { label: "$", from: "#5ea3f5", mid: "#2775CA", to: "#164a8a", ring: "#cfe3fb", alt: "USDC" },
};

function FlatCoin({ cur, size }) {
  const id = useId().replace(/:/g, "");
  const c = FLAT[cur];
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" role="img" aria-label={c.alt} data-testid={`coin-img-${cur}`} className="shrink-0">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={c.from} /><stop offset="0.55" stopColor={c.mid} /><stop offset="1" stopColor={c.to} />
        </linearGradient>
      </defs>
      <circle cx="20" cy="20" r="19" fill={`url(#g${id})`} />
      <circle cx="20" cy="20" r="15.5" fill="none" stroke={c.ring} strokeOpacity="0.55" strokeWidth="1.6" />
      <text x="20" y="20" dy="0.36em" textAnchor="middle" fill="#fff" fontFamily="Outfit, sans-serif" fontWeight="900" fontSize={c.label.length > 1 ? 14 : 19} letterSpacing="-0.5">{c.label}</text>
    </svg>
  );
}

export const CoinIcon = ({ cur = "gc", size = 16 }) => {
  if (cur !== "gc") return <FlatCoin cur={cur} size={size} />;
  return (
    <span className="inline-block shrink-0 rounded-full overflow-hidden" style={{ width: size, height: size }}>
      <img src={GC_IMG} alt="Gold Coin" data-testid="coin-img-gc" className="w-full h-full object-cover scale-[1.12]" draggable={false} />
    </span>
  );
};

const GC_IMG = "https://static.prod-images.emergentagent.com/jobs/68f7bef0-9abd-46b0-a693-8b3a6d0b8517/images/4a991f14f74716b8632f7e99f787a1a454cafe1c7a7014f1ed15e85b584b6479.jpeg";
